import { Badge, Box, Button, ButtonGroup, HStack, Link, SimpleGrid } from '@chakra-ui/react';
import { useMemo, useState } from 'react';
import { Column } from 'react-table';
import { DateTime } from 'luxon';
import TableComponent from 'components/TableComponent';
import { maskCurrency } from 'utils/number';
import { findReceivedFees, getBalancesFeesBySeller } from 'services/api.service';
import { TypeRender } from './balances';

export default function FeesSummary() {
  const [view, setView] = useState<'seller' | 'entry'>('seller');
  const [seller, setSeller] = useState<{ id: string; name: string } | null>(null);

  const sellerColumns = useMemo(
    () =>
      [
        {
          Header: 'Vendedor',
          accessor: 'originName',
          Cell: ({ value, row }: any) => (
            <Link
              color="blue.500"
              onClick={() => {
                setSeller({ id: row.original.originCustomerId, name: value || '---' });
                setView('entry');
              }}
            >
              {value || '---'}
            </Link>
          ),
        },
        {
          Header: 'Total',
          accessor: 'total',
          Cell: ({ value }: any) => maskCurrency(value),
        },
        {
          Header: 'Nº lançamentos',
          accessor: 'count',
          Cell: ({ value }: any) => value ?? 0,
        },
      ] as Column[],
    [],
  );

  const entryColumns = useMemo(
    () =>
      [
        {
          Header: 'Origem',
          accessor: 'originName',
          Cell: ({ value }: any) => value || '---',
        },
        {
          Header: 'Tipo',
          accessor: 'type',
          Cell: ({ value, row }: any) => TypeRender(value, row.original.amount),
        },
        {
          Header: 'Valor',
          accessor: 'amount',
          Cell: ({ value }: any) => maskCurrency(value),
        },
        {
          Header: 'Descrição',
          accessor: 'description',
          Cell: ({ value }: any) => value || '---',
        },
        {
          accessor: 'createdAt',
          Header: 'Data',
          Cell: ({ value }: any) =>
            value ? DateTime.fromISO(value).toFormat('dd/MM/yyyy HH:mm:ss') : '---',
        },
      ] as Column[],
    [],
  );

  const actions = () => null;

  return (
    <Box>
      <HStack mb="16px" spacing={3}>
        <ButtonGroup isAttached size="sm" variant="outline">
          <Button isActive={view === 'seller'} onClick={() => setView('seller')}>
            Por vendedor
          </Button>
          <Button isActive={view === 'entry'} onClick={() => setView('entry')}>
            Por lançamento
          </Button>
        </ButtonGroup>
        {view === 'entry' && seller && (
          <Badge
            colorScheme="blue"
            cursor="pointer"
            onClick={() => setSeller(null)}
            title="Remover filtro de vendedor"
          >
            {seller.name} ✕
          </Badge>
        )}
      </HStack>

      <SimpleGrid mb="20px" columns={{ sm: 1 }} spacing={{ base: '20px', xl: '20px' }}>
        {view === 'seller' ? (
          <TableComponent
            label="Por vendedor"
            columnsData={sellerColumns}
            filterable={['createdAt']}
            right={<></>}
            queryFn={getBalancesFeesBySeller}
            queryKey="getBalancesFeesBySeller"
            actions={actions}
            feesSummary
          />
        ) : (
          <TableComponent
            label="Por lançamento"
            columnsData={entryColumns}
            filterable={['createdAt']}
            right={<></>}
            queryFn={(p: any) =>
              findReceivedFees(seller ? { ...p, originCustomerId: seller.id } : p)
            }
            queryKey={seller ? `findReceivedFees-${seller.id}` : 'findReceivedFees'}
            actions={actions}
            feesSummary
          />
        )}
      </SimpleGrid>
    </Box>
  );
}
